function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  fill: "#007EAE",
  cx: 20,
  cy: 20,
  r: 20
}), React.createElement("path", {
  d: "M16.5 14.111a.77.77 0 00.293.59l5.96 4.966-5.96 4.966c-.391.325-.391.853 0 1.179.39.325 1.024.325 1.414 0l6.667-5.556a.77.77 0 00.293-.59.77.77 0 00-.293-.589l-6.667-5.555c-.286-.239-.716-.31-1.09-.181-.374.129-.617.433-.617.77z",
  fill: "#FFF",
  fillRule: "nonzero"
}));

var SvgRoundArrow = function SvgRoundArrow(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 40 40"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDAgNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGZpbGw9IiMwMDdFQUUiIGN4PSIyMCIgY3k9IjIwIiByPSIyMCIvPjxwYXRoIGQ9Ik0xNi41IDE0LjExMWEuNzcuNzcgMCAwMC4yOTMuNTlsNS45NiA0Ljk2Ni01Ljk2IDQuOTY2Yy0uMzkxLjMyNS0uMzkxLjg1MyAwIDEuMTc5LjM5LjMyNSAxLjAyNC4zMjUgMS40MTQgMGw2LjY2Ny01LjU1NmEuNzcuNzcgMCAwMC4yOTMtLjU5Ljc3Ljc3IDAgMDAtLjI5My0uNTg5bC02LjY2Ny01LjU1NWMtLjI4Ni0uMjM5LS43MTYtLjMxLTEuMDktLjE4MS0uMzc0LjEyOS0uNjE3LjQzMy0uNjE3Ljc3eiIgZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9nPjwvc3ZnPg==";
export { SvgRoundArrow as ReactComponent };